import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

// Context
import ContextConsumer from '../../../contextProvider';

const Wrapper = styled.fieldset`
  margin: 0 0 0.5em;
  select,
  input {
    display: block;
    margin-bottom: 1em !important;
    &:focus {
      outline: 0;
    }
  }
  input {
    cursor: text;
  }

  select {
    border: none;
    height: 2.7777777778rem;
    text-indent: 0.6rem;
  }

  select,
  input {
    &.dates-input,
    &.guests-input {
      cursor: pointer;
      background-position: center right 1em;
      background-size: 20px auto;
      background-repeat: no-repeat;
      margin-bottom: 1em !important;
      &:focus {
        outline: 0;
      }
    }
    &.dates-input {
      background-image: url('data:image/svg+xml;utf8;base64,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');
    }
    &.guests-input {
      background-image: url('data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDU2My40MyA1NjMuNDMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDU2My40MyA1NjMuNDM7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiPgo8cGF0aCBkPSJNMjgwLjc5LDMxNC41NTljODMuMjY2LDAsMTUwLjgwMy02Ny41MzgsMTUwLjgwMy0xNTAuODAzUzM2NC4wNTUsMTMuNDE1LDI4MC43OSwxMy40MTVTMTI5Ljk4Nyw4MC45NTMsMTI5Ljk4NywxNjMuNzU2ICBTMTk3LjUyNCwzMTQuNTU5LDI4MC43OSwzMTQuNTU5eiBNMjgwLjc5LDUyLjczNWM2MS4wNjEsMCwxMTEuMDIxLDQ5Ljk1OSwxMTEuMDIxLDExMS4wMjFTMzQxLjg1MSwyNzQuNzc2LDI4MC43OSwyNzQuNzc2ICBzLTExMS4wMjEtNDkuOTU5LTExMS4wMjEtMTExLjAyMVMyMTkuNzI4LDUyLjczNSwyODAuNzksNTIuNzM1eiIgZmlsbD0iIzAwMDAwMCIvPgo8cGF0aCBkPSJNMTkuODkxLDU1MC4wMTVoNTIzLjY0OGMxMS4xMDIsMCwxOS44OTEtOC43ODksMTkuODkxLTE5Ljg5MWMwLTEwNC4wODItODQuNjUzLTE4OS4xOTgtMTg5LjE5OC0xODkuMTk4SDE4OS4xOTggIEM4NS4xMTYsMzQwLjkyNiwwLDQyNS41NzksMCw1MzAuMTI0QzAsNTQxLjIyNiw4Ljc4OSw1NTAuMDE1LDE5Ljg5MSw1NTAuMDE1eiBNMTg5LjE5OCwzODAuNzA4aDE4NS4wMzQgIGM3NS44NjQsMCwxMzguMzEzLDU2LjQzNiwxNDguMDI4LDEyOS41MjRINDEuMTdDNTAuODg0LDQzNy42MDcsMTEzLjMzNCwzODAuNzA4LDE4OS4xOTgsMzgwLjcwOHoiIGZpbGw9IiMwMDAwMDAiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==');
    }
  }
`;

const Legend = styled.legend`
  width: 100%;
  font-size: 25px;
  margin-top: 20px;
  margin-bottom: 20px;
  font-weight: 400;
  font-family: ${props => props.theme.fonts.header};
  &:first-child {
    margin-top: 0;
  }
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    text-align: left;
  }
`;

const Label = styled.label`
  font-family: ${props => props.theme.fonts.body};
  line-height: 1.2em;
  font-size: 0.7em;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  font-weight: bolder;
  margin: 0;
  color: ${props => props.theme.colors.text.dark};
  display: block;
  margin-top: 0.1em;
  margin-bottom: 0.5em;
  @media screen and (max-width: ${props => props.theme.responsive.medium}) {
    font-size: 0.65em;
  }
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    font-size: 0.69em;
    text-align: left;
  }
  &.checkBox {
    position: relative;
    padding-left: 30px;
    margin-top: 8px;
  }
`;

const Dates = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: center;
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
`;

const Guests = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: flex-start;
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  > div {
    &:last-child {
      margin-bottom: 0.5em;
    }
  }
`;

const Personal = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  align-items: flex-start;
  @media screen and (max-width: ${props => props.theme.responsive.small}) {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }
  > div {
    &:last-child {
      margin-bottom: 0.5em;
    }
  }
`;

const Message = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  > div {
    &:last-child {
      margin-bottom: 0.5em;
    }
  }
  textarea {
    height: 6em;
    line-height: 1.5;
    cursor: text;
    padding: 5px 15px;
    &:focus {
      outline: none;
    }
  }
  input[type='checkbox'] {
    position: absolute;
    top: 5px;
    left: 0;
    cursor: pointer;
  }
`;

const AdultsSelect = props => {
  const adults = [];
  for (let i = 1; i < props.numTimes; i += 1) {
    adults.push(props.children(i));
  }
  return adults;
};

const ChildsSelect = props => {
  const childs = [];
  for (let i = 0; i < props.numTimes; i += 1) {
    childs.push(props.children(i));
  }
  return childs;
};

const Form = () => (
  <ContextConsumer>
    {({
      handleEnquiryChange,
      handleEnquiryConsent,
      consent,
      calendarDates,
      toggleDates,
      adults,
      childs,
      handleChangeAdults,
      handleChangeChilds
    }) => (
      <Wrapper className="booking">
        <Legend>Arrival &amp; Departure</Legend>
        <Dates>
          <div>
            <Label>From</Label>
            <input
              className="dates-input"
              type="text"
              name="checkinDate"
              id="checkinDate"
              placeholder="Check-in"
              readOnly
              value={moment(calendarDates.startDate).format('MMMM Do, YYYY')}
              onClick={toggleDates}
            />
          </div>
          <div>
            <Label>to</Label>
            <input
              className="dates-input"
              type="text"
              name="checkoutDate"
              id="checkoutDate"
              placeholder="Check-out"
              readOnly
              value={moment(calendarDates.endDate).format('MMMM Do, YYYY')}
              onClick={toggleDates}
            />
          </div>
        </Dates>
        <Legend>Number of Guests</Legend>
        <Guests>
          <div>
            <Label>Adults</Label>
            <select
              className="guests-input"
              name="adults"
              id="adults"
              value={adults}
              onChange={handleChangeAdults}
            >
              <AdultsSelect numTimes={11}>
                {index => (
                  <option key={index} value={index}>
                    {index} Adults
                  </option>
                )}
              </AdultsSelect>
            </select>
          </div>
          <div>
            <Label>Children</Label>
            <select
              className="guests-input"
              name="childs"
              id="childs"
              value={childs}
              onChange={handleChangeChilds}
            >
              <ChildsSelect numTimes={11}>
                {index => (
                  <option key={index} value={index}>
                    {index} Children
                  </option>
                )}
              </ChildsSelect>
            </select>
          </div>
        </Guests>
        <Legend>Personal Information</Legend>
        <Personal>
          <div>
            <Label>First Name*</Label>
            <input
              type="text"
              name="firstName"
              id="firstName"
              placeholder="First name"
              onChange={handleEnquiryChange}
            />
          </div>
          <div>
            <Label>Last Name</Label>
            <input
              type="text"
              name="lastName"
              id="lastName"
              placeholder="Last name"
              onChange={handleEnquiryChange}
            />
          </div>
          <div>
            <Label>Email*</Label>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="Email address"
              onChange={handleEnquiryChange}
            />
          </div>
          <div>
            <Label>Phone</Label>
            <input
              type="tel"
              name="phone"
              id="phone"
              placeholder="Phone number"
              onChange={handleEnquiryChange}
            />
          </div>
        </Personal>
        <Message>
          <div>
            <Label>Do you have any requests?</Label>
            <textarea
              name="message"
              id="message"
              onChange={handleEnquiryChange}
            />
          </div>
          <div style={{ position: `relative`, margin: `1em 0` }}>
            <Label className="checkBox">
              I give my consent to the processing of my personal details*
            </Label>
            <input
              type="checkbox"
              onChange={handleEnquiryConsent}
              checked={consent}
              name="consent"
              id="consent"
            />
          </div>
        </Message>
      </Wrapper>
    )}
  </ContextConsumer>
);

export default Form;
